<template>
  <div v-if="has_scorecard_store">
    <div class="match-info-head-wrap">
      <h1 itemprop="headline" class="head-title">{{ generateHeadline() }}</h1>
      <p>{{ generateDesc() }}</p>
    </div>
    <gamezy-ad size="mob_small" ad_id="mob_small-ad-1" :autoDetect="true" />
    <gamezy-ad size="web_small" ad_id="web_small-ad-1" :autoDetect="true" />
    <cricket-scorecard v-if="cricketScore" :details="cricketScore" :current_match="current_match" />
    <football-scorecard v-if="footballTimeline" :details="footballTimeline" :current_match="current_match" />
  </div>
</template>
<script>
import {
  cssImport,
  getMatch,
  getMatchInfoTitle
} from "../../../assets/js/common";
import CricketScorecard from "./CricketScorecard";
import FootballScorecard from "./FootballScorecard";
import scorecardStore from "../../../store/modules/matchDetails/scorecardStore";
import GamezyAd from '../../common/GamezyAd';
export default {
  props: ["parentRoute"],
  data() {
    return {
      scorecardUpdateTimeout: null,
      fixtureTimeout: null
    }
  },
  components: {
    CricketScorecard,
    FootballScorecard,
    GamezyAd
  },
  computed: {
    has_scorecard_store() {
      return !!(this.$store.state && this.$store.state.scorecard_store && this.$store.state.scorecard_store.scorecards_store_filled);
    },
    match_data() {
      return this.$store.state.match_detail_store.match_data;
    },
    slug() {
      return this.$store.state.match_detail_store.slug;
    },
    isLiveScoringActive() {
      return this.$store.state.match_detail_store.isLiveScoringActive;
    },
    current_match() {
      return getMatch(this.match_data, "slug", this.slug) || {};
    },
    cricketScore() {
      return this.$store.state.scorecard_store.cricketScore;
    },
    footballTimeline() {
      return this.$store.state.scorecard_store.footballTimeline;
    },
    realtime_update() {
      return this.$store.state.scorecard_store.realtime_update;
    },
    translations() {
      return this.$store.state.translations;
    },
  },
  async serverPrefetch() {
    // serverPrefetch runs only on serverside
    this.$store.registerModule("scorecard_store", scorecardStore);
    return await this.$store.dispatch("scorecard_store/fetchMatchFile");
  },
  beforeMount() {
    this.registerModule();
  },
  mounted() {
    let hasStore = this.has_scorecard_store;
    if(!hasStore){
      cssImport(["/static-assets/css/scorecard-details.css"])
      this.callApis();
    } else {
      this.checkLiveScorecard();
    }
  },
  methods: {
    registerModule() {
      let hasComponentModule = this.$store.hasModule("scorecard_store");
      if (!hasComponentModule) {
        this.$store.registerModule("scorecard_store", scorecardStore, {
          preserveState: this.has_scorecard_store,
        });
      }
    },
    callApis() {
      this.componentPromises = this.initApis();
      this.componentPromises.then(() => {
        // start live update if required 
        this.checkLiveScorecard();
      });
    },
    async initApis() {
      return await this.$store.dispatch("scorecard_store/fetchMatchFile");
    },
    getTranKey() {
      let key = `scorecard_headline_1`;
      if(this.current_match && this.current_match.sport_id) {
        let transKey = `scorecard_headline_${this.current_match.sport_id}`;
        if(this.isLiveScoringActive) {
          transKey = `scorecard_headline_live_${this.current_match.sport_id}`
        }
        if(this.translations[transKey]) {
          key = transKey;
        }
      }
      return key;
    },
    generateDesc() {
      let key = this.getTranKey();
      return getMatchInfoTitle(
        this.current_match,
        this.translations[key],
        false,
        false,
        true
      );
    },
    generateHeadline() {
      let key = this.getTranKey();
      return getMatchInfoTitle(
        this.current_match,
        this.translations[key]
      );
    },
    checkLiveScorecard() {
      this.callRealTimeFixture();
      this.callRealTimeScorecard();
    },
    callRealTimeFixture() {
      if(this.fixtureTimeout) { clearTimeout(this.fixtureTimeout) }
      if(this.realtime_update && this.realtime_update.matchFixture) {
        this.fixtureTimeout = setTimeout(() => {
          this.$store.dispatch("match_detail_store/fetchMatchData");
          this.callRealTimeFixture();
        }, this.realtime_update.matchFixture);
      }
    },
    callRealTimeScorecard() {
      if(this.scorecardUpdateTimeout) { clearTimeout(this.scorecardUpdateTimeout) }
      if(this.realtime_update && this.realtime_update.scoreboard) {
        this.scorecardUpdateTimeout = setTimeout(() => {
          this.$store.dispatch("scorecard_store/fetchMatchFile");
          this.callRealTimeScorecard();
        }, this.realtime_update.scoreboard);
      }
    }
  },
  beforeDestroy() {
    if(this.scorecardUpdateTimeout) { clearTimeout(this.scorecardUpdateTimeout) }
    if(this.fixtureTimeout) { clearTimeout(this.fixtureTimeout) }
    this.$store.dispatch("scorecard_store/resetScorecard");
  },
  unmounted() {
    if (this.componentPromises) {
      this.componentPromises.then(() => {
        this.$store.unregisterModule("scorecard_store");
      });
    } else {
      this.$store.unregisterModule("scorecard_store");
    }
  },
};
</script>
